import api from './client';
import type { AuditoriaFiltros, AuditoriaResponse } from '../types/auditoria';

export const auditoriaApi = {
  listar: async (filtros: AuditoriaFiltros): Promise<AuditoriaResponse> => {
    const params = new URLSearchParams();
    Object.entries(filtros).forEach(([k, v]) => {
      if (v === undefined || v === null) return;
      const s = String(v);
      if (s.length === 0) return;
      params.set(k, s);
    });
    const resp = await api.get<AuditoriaResponse>(`/auditoria?${params.toString()}`);
    return resp.data;
  },

  tipos: async (): Promise<string[]> => {
    const resp = await api.get<{ success: boolean; data: string[] }>('/auditoria/tipos');
    return resp.data.data;
  },

  usuariosDistintos: async (): Promise<string[]> => {
    const resp = await api.get<{ success: boolean; data: string[] }>('/auditoria/usuarios-distintos');
    return resp.data.data;
  },
};
